module.exports = __webpack_public_path__ + "img/9-estatus-completado.5a813319.svg";